<template>
  <div class="d-contents">
    <v-menu v-if="field === 'unit' && !this.groupLevel" absolute>
      <template v-slot:activator="{ on, attrs }">
        <div
          :id="cellColumnRow"
          v-bind="attrs"
          class="cell import-cell flex-row flex-justify-between"
          :class="{ 'import-error': error }"
          v-on="on"
        >
          <div>{{ unitName(text) || text }}</div>
          <ChevronIcon />
          <template v-if="error">
            <div :class="errorPosition" class="error">
              <div class="error-black-wrap">
                <ErrorIcon class="error-icon" />
                <div>{{ error && error.description }}</div>
              </div>
            </div>
          </template>
        </div>
      </template>
      <div class="dropdown-body dropdown-body_fit dropdown-body_height-limited-250">
        <DropdownMenuElement
          v-for="unit in units"
          :key="unit.id"
          @click="editCellValueHandler(unit)"
        >
          {{ unitName(unit.name) }}
        </DropdownMenuElement>
      </div>
    </v-menu>
    <div
      v-else
      :id="cellColumnRow"
      ref="cellValueWrapper"
      class="cell import-cell"
      :contenteditable="contentEditable"
      :class="{
        'import-error': error,
        'cursor-not-allowed': !contentEditable,
        'cell-can-be-edited': contentEditable,
      }"
      @blur="blurCellValueHandler"
      @paste="keydownCellValue"
      @click="focusValue"
    >
      <div
        :id="cellId"
        :key="text"
        ref="cellValue"
        class="import-cell__text"
        :contenteditable="contentEditable"
        @click.stop
      >
        {{ text }}
      </div>
      <template v-if="error">
        <div :class="errorPosition" class="error" :contenteditable="false">
          <div class="error-black-wrap">
            <ErrorIcon class="error-icon" />
            <div>{{ error && error.description }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import ErrorIcon from '@/assets/icons/error.svg';
  import contenteditableCell from '@/utils/mixins/contenteditable-cell';
  import { mapState } from 'vuex';
  import { VMenu } from 'vuetify/lib';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import ChevronIcon from '@/assets/icons/chevron-down.svg';
  import unitName from '@/utils/mixins/get-unit-name';

  export default {
    name: 'ImportCell',
    components: { ErrorIcon, VMenu, DropdownMenuElement, ChevronIcon },
    mixins: [contenteditableCell, unitName],
    props: {
      text: {
        type: [String, Number],
        default: '',
      },
      rowId: {
        type: Number,
        required: true,
      },
      field: {
        type: String,
        required: true,
      },
      error: {
        type: Object,
        default: null,
      },
      groupLevel: {
        type: Number,
        required: true,
      },
      errorPosition: String,
      cellColumnRow: String,
    },
    computed: {
      ...mapState('global', ['units']),
      contentEditable() {
        return (!this.groupLevel && this.field !== 'unit') || this.field === 'description_of_works';
      },
    },
    methods: {
      blurCellValueHandler(e) {
        this.blurCellValue(e, { rowId: this.rowId, key: this.field, oldValue: this.text });
      },
      editCellValueHandler(unit) {
        this.$emit('edit-cell-value', {
          key: 'unit',
          value: unit.name,
          oldValue: this.text,
          rowId: this.rowId,
        });
      },
    },
  };
</script>
